// extracted by mini-css-extract-plugin
module.exports = {"container":"Work_container__2eEmd","layout":"Work_layout__3dE02"};